import _classCallCheck from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * DevExtreme (esm/ui/text_box/ui.text_editor.clear.js)
 * Version: 21.2.4
 * Build date: Mon Dec 06 2021
 *
 * Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import $ from "../../core/renderer";
import eventsEngine from "../../events/core/events_engine";
import TextEditorButton from "./texteditor_button_collection/button";
import { addNamespace } from "../../events/utils/index";
import pointer from "../../events/pointer";
import { name as click } from "../../events/click";
var pointerDown = pointer.down;
var STATE_INVISIBLE_CLASS = "dx-state-invisible";
var TEXTEDITOR_CLEAR_BUTTON_CLASS = "dx-clear-button-area";
var TEXTEDITOR_CLEAR_ICON_CLASS = "dx-icon-clear";
var TEXTEDITOR_ICON_CLASS = "dx-icon";
var TEXTEDITOR_SHOW_CLEAR_BUTTON_CLASS = "dx-show-clear-button";

var ClearButton = /*#__PURE__*/function (_TextEditorButton) {
  _inherits(ClearButton, _TextEditorButton);

  function ClearButton() {
    _classCallCheck(this, ClearButton);

    return _possibleConstructorReturn(this, _getPrototypeOf(ClearButton).apply(this, arguments));
  }

  _createClass(ClearButton, [{
    key: "_create",
    value: function _create() {
      var $element = $("<span>").addClass(TEXTEDITOR_CLEAR_BUTTON_CLASS).append($("<span>").addClass(TEXTEDITOR_ICON_CLASS).addClass(TEXTEDITOR_CLEAR_ICON_CLASS));

      this._addToContainer($element);

      this.update(true);
      return {
        instance: $element,
        $element: $element
      };
    }
  }, {
    key: "_isVisible",
    value: function _isVisible() {
      var editor = this.editor;
      return editor._isClearButtonVisible();
    }
  }, {
    key: "_attachEvents",
    value: function _attachEvents(instance, $button) {
      var editor = this.editor;
      var editorName = editor.NAME;
      eventsEngine.on($button, addNamespace(pointerDown, editorName), function (e) {
        e.preventDefault();

        if ("mouse" !== e.pointerType) {
          editor._clearValueHandler(e);
        }
      });
      eventsEngine.on($button, addNamespace(click, editorName), function (e) {
        return editor._clearValueHandler(e);
      });
    }
  }, {
    key: "_legacyRender",
    value: function _legacyRender($editor, isVisible) {
      $editor.toggleClass(TEXTEDITOR_SHOW_CLEAR_BUTTON_CLASS, isVisible);
    }
  }, {
    key: "update",
    value: function update() {
      var rendered = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : false;
      !rendered && _get(_getPrototypeOf(ClearButton.prototype), "update", this).call(this);
      var editor = this.editor,
          instance = this.instance;
      var $editor = editor.$element();

      var isVisible = this._isVisible();

      instance && instance.toggleClass(STATE_INVISIBLE_CLASS, !isVisible);

      this._legacyRender($editor, isVisible);
    }
  }]);

  return ClearButton;
}(TextEditorButton);

export { ClearButton as default };